import React from "react";
import styles from "./PasswordRequirements.module.css";

const REQUIREMENTS = [
  { key: "len", label: "At least 8 characters", test: (s) => s.length >= 8 },
  { key: "upper", label: "One uppercase letter", test: (s) => /[A-Z]/.test(s) },
  { key: "number", label: "One number", test: (s) => /\d/.test(s) },
  {
    key: "special",
    label: "One special character",
    test: (s) => /[^A-Za-z0-9]/.test(s),
  },
];

/** Live password-strength checklist for the Create New Password screen. */
const PasswordRequirements = ({ password = "" }) => {
  return (
    <div className={styles.box}>
      <p className={styles.heading}>Password must contain:</p>
      <ul className={styles.list}>
        {REQUIREMENTS.map((r) => {
          const ok = r.test(password);
          return (
            <li key={r.key} className={ok ? styles.itemOk : styles.item}>
              <span className={styles.check} aria-hidden="true">
                <svg
                  width="14"
                  height="14"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="3"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <polyline points="5 12 10 17 19 8" />
                </svg>
              </span>
              <span>{r.label}</span>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export const isPasswordValid = (password = "") =>
  REQUIREMENTS.every((r) => r.test(password));

export default PasswordRequirements;
